export default (node) => {
  const speed = node.dataset.speed;
  const uspLength = parseInt(node.dataset.uspLength);
  const uspItems = node.querySelectorAll('[data-usp-item]');
  const uspCurrentIndex = node.querySelector('[data-usp-current-index]');
  const init = () => {
    // Don't animate if there's only one USP
    if (uspLength <= 1) {
      return;
    }

    setInterval(() => {
      const activeIndex = parseInt(uspCurrentIndex.textContent) - 1;
      const nextIndex = activeIndex === uspLength - 1 ? 0 : activeIndex + 1;

      uspCurrentIndex.textContent = parseInt(uspCurrentIndex.textContent) + 1;
      if (parseInt(uspCurrentIndex.textContent) > uspLength) {
        uspCurrentIndex.textContent = 1;
      }

      uspItems.forEach((item) => {
        item.classList.remove('animate-in');
        item.classList.remove('animate-out');
        item.setAttribute('aria-hidden', 'true');
      });

      uspItems[activeIndex].classList.add('animate-out');
      uspItems[nextIndex].classList.add('animate-in');
      uspItems[nextIndex].setAttribute('aria-hidden', 'false');
    }, speed);
  };

  if (uspItems.length) {
    init();
  }
};
